<template>
  <div>
    <div class="login" v-if="pageIndex == 0">
      <div class="bg"></div>
      <div class="con">
        <div class="form" v-loading="loading">
          <div class="content">
            <h1>Welcome to iDentSmile</h1>
            <p>Full Name</p>
            <div class="div" :class="actType == 1 ? 'act' : ''">
              <i class="el-icon-reading"></i>
              <input placeholder="Full Name" @focus="actType = 1" @blur="actType = 0" v-model="model.fullName"/>
            </div>
            <p>Practice name</p>
            <div class="div" :class="actType == 2 ? 'act' : ''">
              <i class="el-icon-s-check"></i>
              <input placeholder="Practice name" @focus="actType = 2" @blur="actType = 0" v-model="model.practiceName"/>
            </div>
            <p>Email</p>
            <div class="div" :class="actType == 3 ? 'act' : ''">
              <i class="el-icon-user"></i>
              <input placeholder="Email" @focus="actType = 3" @blur="actType = 0" v-model="model.email"/>
            </div>
            <p>Password</p>
            <div class="div" :class="actType == 4 ? 'act' : ''">
              <i class="el-icon-lock"></i>
              <input :type="type" @focus="actType = 4" v-model="model.password"  @blur="actType = 0" placeholder="Password"/>
              <img class="pass" v-if="type == 'password'" @click="changeType" src="../assets/imgs/un_visibility.png"/>
              <img class="pass" v-else @click="changeType" src="../assets/imgs/visibility.png"/>
            </div>
            <p>Confirm Password</p>
            <div class="div" :class="actType == 5 ? 'act' : ''">
              <i class="el-icon-lock"></i>
              <input :type="type" @focus="actType = 5" v-model="model.password2" @blur="actType = 0" placeholder="Confirm Password"/>
              <img class="pass" v-if="type == 'password'" @click="changeType" src="../assets/imgs/un_visibility.png"/>
              <img class="pass" v-else @click="changeType" src="../assets/imgs/visibility.png"/>
            </div>
            <div class="rem">
              <label>
                <input class="input" v-model="model.hasPromotionCode" type="checkbox"/>
                I Have Promo Code
              </label>
            </div>
            <div class="div" :class="actType == 3 ? 'act' : ''" v-if="model.hasPromotionCode == true">
              <i class="el-icon-trophy"></i>
              <input placeholder="Promo Code" @focus="actType = 3" @blur="actType = 0" v-model="model.promotionCode"/>
            </div>

            <div class="error" v-if="error != ''">
              <div>
                <i class="el-icon-circle-close"></i>
                <p>{{error}}</p>
                <i class="el-icon-close" @click="error = ''"></i>
              </div>
            </div>
            <div class="btn" @click="loginFunction">Create Account</div>
            <div class="copy">Copyright © {{moment().format('YYYY')}}  SMILEWISH Co. Ltd. All rights reserved</div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="emailWait">
      <img src="../assets/imgs/icons/email_wait_icon.jpg"/>
      <h2>Please confirm your email address</h2>
      <hr/>
      <h3>Thanks for signing up to Dental System.We're happy to have you.</h3>
    </div>
  </div>

</template>

<script>
  import { mapActions } from 'vuex'
  import Vue from 'vue'
  import { ACCESS_TOKEN } from "@/store/mutation-types"
  import moment from 'moment/moment';
  import { postAction } from '@/network/manage';

  export default {
    name: 'Register',
    components: {
    },
    data() {
      return {
        type:'password',
        loading:false,
        error:'',
        model:{},
        pageIndex:0,
        actType:0,
        remember:false
      }
    },
    computed: {

    },
    created() {

    },
    methods: {
      moment,
      loginFunction(){
        this.error = ''
        const testStr = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
        const passStr = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]])[A-Za-z\d`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]]{6,18}$/
        if(!this.model.fullName){
          this.error = 'FullName is required';
        }else if(!this.model.practiceName){
          this.error = 'Practice Name is required';
        }else if(!this.model.email){
          this.error = 'Email is required';
        }else if(!testStr.test(this.model.email)){
          this.error = 'Email format incorrect'
        }else if(!this.model.password){
          this.error = 'Password is required';
        }else if(!passStr.test(this.model.password)){
          this.error = 'Combinations of alphanumeric and special symbols within 6 to 18 characters';
        }else if(!this.model.password2){
          this.error = 'Confirm Password is required';
        }else if(this.model.password != this.model.password2){
          this.error = 'Passwords do not match.';
        }else if(this.model.hasPromotionCode == true && !this.model.promotionCode){
          this.error = 'Promo Code is required';
        }else {
          this.error = ''
          this.loading = true
          const that = this
          postAction('/sys/register',this.model).then((res) => {
            if(res.success){
              this.pageIndex = 1
              this.model = {}
            }else{
              this.error = res.message
            }
          }).catch((err) => {
            this.error = err.message
          }).finally((res) => {
            this.loading = false
          });
        }
      },
      changeType(){
        this.type = this.type == 'password' ? 'text' : 'password'
      },
      go(url){
        this.$router.push(url);
      }
    }
  }
</script>

<style scoped>
  *{font-size:16px;font-size:inherit;box-sizing: border-box;margin:0px;padding:0px;}
  .emailWait{display: flex;align-items: center;flex-direction: column;background-color: #ffffff;min-height: 100vh;padding-top:200px;color:#034844;}
  .emailWait h2{font-size: 20px;font-weight: normal;margin:20px 0;}
  .emailWait hr{background-color: #ededed;height: 1px;width:460px;border: none;margin:20px 0;}
  .emailWait h3{font-size: 14px;font-weight: normal;}
  .login{display: flex;justify-content: center;align-items: center;min-height:100vh;flex-direction: column;background: linear-gradient(rgba(3, 72, 68, 0.75),rgba(7, 174, 164, 0.225));}
  .bg{position: fixed;top:0;left:0;width:100vw;height:100vh;display: flex;z-index:-1;background-image: url(../assets/imgs/home_bg.png);background-size: auto 100%;background-position:right center;}
  .con{width: 1200px;display: flex;justify-content: flex-end;margin: auto;}
  .form{z-index:2;width:700px;display: flex;background-color: #97A295;}
  .content{background-color: #F9F3EE;width:100%;min-height:100vh;padding:30px 60px;display: flex;flex-direction: column;}
  .content p{margin:10px 0;}
  .form h1{color:#034844;font-size:28px;margin:20px 0;line-height: 1;align-self: center;}
  .form span{color:#A0AEC0;font-size:14px;margin-top:10px;margin-bottom:32px;}
  .form .div{border: 1px solid #CBD5E0;background:#ffffff;border-radius: 6px;overflow: hidden;margin-bottom:6px;padding:10px 14px;display: flex;align-items: center;}
  .form .div i{margin-right: 10px;flex-shrink: 0;color:#034844;font-size: 18px;}
  .form .act{border:1px solid #034844;}
  .form input{border:none;height:20px;font-size:14px;width: 100%;}
  .form .rem{display: flex;justify-content: space-between;align-items: center;font-size:12px;margin:20px 0;}
  .form .btn{height:40px;width:50%;min-width:200px;background-color: #8BB2B2;cursor: pointer;color:#ffffff;font-size:17px;display: flex;align-items: center;justify-content: center;border-radius: 4px;margin:20px 0;align-self: center;}
  .form .copy{color:#A0AEC0;font-size:12px;align-self: center;}
  .form a{color:#A0AEC0;cursor: pointer;}
  .form label{display:flex;align-items: center;color:#718096;}
  .form label .input{width:20px;height:20px;border-radius: 4px;margin-right:10px;}
  .form .pass{width:20px;height:20px;cursor: pointer;}
  .error{text-align: center;margin-top:20px;width: 100%;text-align: left;border: 1px solid #FF4528;border-radius: 2px;margin-bottom:20px;background-color: rgba(255, 69, 40, 0.1);padding:10px;font-size: 12px;display: flex;flex-direction: column;}
  .error div{width: 100%;display: flex;}
  .error div i{color:#595959;font-size: 20px;flex-shrink: 0;}
  .error div i:first-child{color:#FF4528;font-weight: bold;}
  .error div i:last-child{cursor: pointer;}
  .error div p{width: 100%;color:#FF4528;font-size:14px;font-weight: bold;margin:0 10px;}
  .error .span{padding-left:30px;color:#000000;}
  .reg{padding:10px 0;color: rgba(0, 0, 0, 0.3);cursor: pointer;}
  @media (max-width: 768px) {
    .emailWait{padding-top:50px;padding:100px 5vw 0 5vw;}
    .emailWait img{width: 30vw;}
    .emailWait hr{width:90vw;}
    .form h1{font-size:20px;}
    .con{width: 100%;}
    .form{width: 100vw;}
    .content{padding:30px 30px;background-color: #ffffff;}
  }
  @media screen and (min-width: 769px) and (max-width: 1024px) {
    .bg{background-position: left 160vh center;}
    .con{width: 100%;}
    .form{width: 70vw;}
    .content{padding:30px 20px;}
  }
</style>
